export const API_URL = 'https://order.ellaapp.com/admin/web/v1/';
export const API_URL2 = 'https://order.ellaapp.com/admin/web/';
export const LOCAL_PAYMENT_API_URL = "http://localhost";
export const LOCAL_PAYMENT_PORT = "5000";
export const SUICA_SERVER = "7700";
export const PRINT_TIMEOUT = 20000;
export const telemetryTimeout = 5000;
export const setIntervalTimeOut =1000;
export const QRcodeTimeout = 10000;
export const timer_time = 30;
export const payment_timer = 30;
export const modalTimeout = 6000;
export const PRINT_API_URL = "http://localhost:3333/?purl=";
export const KIOSK_AUTO_LOGIN ="https://scbkiosk.ellaapp.com/kioskautologin/4fc1fd38785fd9594d0ae3b617cbf9f9/603d5e7bc496fadc0de28f40b7217bd4";
export const page_redirection_time = 30;
export const enable_test_buttons = false;
export const payment_failed_modal = 30;
export const settlement_timer = 7;
export const cancel_timeout = 10000;
export const apitimeout = 29000;
export const cart_time = 30;
export const terminalCheck = 10000;
export const terminal_check_enable = true;
export const menu_items_timer = 20000;
export const images_display_timer = 15000;
